import { render, staticRenderFns } from "./CreateTeamRegionModal.vue?vue&type=template&id=7b1889a8&scoped=true&"
import script from "./CreateTeamRegionModal.vue?vue&type=script&lang=js&"
export * from "./CreateTeamRegionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeamRegionModal.vue?vue&type=style&index=0&id=7b1889a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1889a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1889a8')) {
      api.createRecord('7b1889a8', component.options)
    } else {
      api.reload('7b1889a8', component.options)
    }
    module.hot.accept("./CreateTeamRegionModal.vue?vue&type=template&id=7b1889a8&scoped=true&", function () {
      api.rerender('7b1889a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamRegions/Modals/CreateTeamRegionModal.vue"
export default component.exports